import { useEffect, useState } from 'react'
import { useSaleLoaders, useHoardLoaders, useBudgetLoaders, useCustomerLoaders, Budget, Customer, HoardOrder, SaleOrder } from '../../../sales'
import { useSystemStateHooks } from '../../../system'

export type AdminSalesData = {
    sales: SaleOrder[]
    hoards: HoardOrder[]
    budgets: Budget[]
    customers: Customer[]
}

// enabled: false when no visible card needs this data (it isn't loaded)
export const useAdminSalesData = (enabled = true) => {
    const [loading, setLoading] = useState(enabled)
    const [error, setError] = useState(false)
    const [data, setData] = useState<AdminSalesData | null>(null)

    const { companyId } = useSystemStateHooks()
    const saleLoaders = useSaleLoaders()
    const hoardLoaders = useHoardLoaders()
    const budgetLoaders = useBudgetLoaders()
    const customerLoaders = useCustomerLoaders()

    useEffect(() => {
        if (!enabled) return
        setLoading(true)
        const load = async () => {
            try {
                const id = companyId
                const [rawSales, rawHoards, activeBudgets, allCustomers] = await Promise.all([
                    saleLoaders(id).loadAllSales(),
                    hoardLoaders(id).loadAllHoards(),
                    budgetLoaders(id).loadActiveBudgets(),
                    customerLoaders(id).loadAllCustomers()
                ])
                setData({
                    sales: rawSales.filter(s => !s.cancelled && !s.archived),
                    hoards: rawHoards.filter(h => !h.cancelled && !h.archived),
                    budgets: activeBudgets as Budget[],
                    customers: allCustomers
                })
            } catch {
                setError(true)
            } finally {
                setLoading(false)
            }
        }
        load()
    }, [enabled])

    return { loading, error, data }
}
